import { z } from "zod";
import { eventOccasionIdSchema } from "./eventOccasion.schemas";
import { eventOccurrenceIdSchema } from "./eventOccurrence.schemas";
import {
	createEventRegistrationSchema,
	eventRegistrationIdSchema,
} from "./eventRegistration.schemas";

export const memberEventListQuerySchema = z.object({
	categoryId: z.coerce.number().int().positive().optional(),
	date: z.coerce.date().optional(),
	isPaid: z
		.union([z.literal("true"), z.literal("false")])
		.optional()
		.transform((value) => {
			if (value === undefined) return undefined;
			return value === "true";
		}),
	membershipOnly: z
		.union([z.literal("true"), z.literal("false")])
		.optional()
		.transform((value) => {
			if (value === undefined) return undefined;
			return value === "true";
		}),
	page: z.coerce.number().int().min(1).default(1),
	pageSize: z.coerce.number().int().min(1).max(50).default(10),
});

export const memberEventDetailPathParamsSchema = z.object({
	eventOccasionId: eventOccasionIdSchema,
});

export const memberEventRegisterBodySchema = createEventRegistrationSchema
	.pick({
		eventOccurrenceId: true,
		eventOccasionId: true,
		eventCategoryId: true,
		memberId: true,
		nonMemberProfileJson: true,
		primaryParticipantCount: true,
		companionCount: true,
		notesJson: true,
		surveyResponsesJson: true,
	})
	.extend({
		consentToPolicy: z.boolean().default(true),
	});

export const memberRegistrationsQuerySchema = z.object({
	status: z.enum(["pending", "confirmed", "cancelled", "no_show"]).optional(),
	after: z.coerce.date().optional(),
	before: z.coerce.date().optional(),
});

export const memberRegistrationPathParamsSchema = z.object({
	eventRegistrationId: eventRegistrationIdSchema,
});

export const memberCancelRegistrationBodySchema = z.object({
	reason: z.string().max(1000).optional(),
});

export const memberOccurrenceCapacityPathParamsSchema = z.object({
	eventOccurrenceId: eventOccurrenceIdSchema,
});
